'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { getShouldShowGrid, getGridPositions } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  gridPositions: getGridPositions(state),
  shouldShowGrid: getShouldShowGrid(state)
});

/**
 * @param {Object} props.gridPositions (required)
 * @param {boolean} props.shouldShowGrid (required)
 */
class LayoutSectionGridContainer extends Component {
  constructor(props) {
    super(props);
    this.renderOutline = this.renderOutline.bind(this);
  }
  renderOutline(positionInfo, i) {
    const {
      top,
      left,
      height,
      width
    } = positionInfo;
    return /*#__PURE__*/_jsx(View, {
      position: "absolute",
      borderWidth: "100",
      borderColor: "border-core-subtle",
      borderStyle: "solid",
      insetBlockStart: `${Math.round(top)}px`,
      insetInlineStart: `${Math.round(left)}px`
      // Making the bottom edge of the outline one bigger solves _lots_ of grid doubling-up problems
      ,
      blockSize: Math.round(height) + 1,
      inlineSize: Math.round(width),
      pointerEvents: "none"
    }, `cell-outline-${i}`);
  }
  render() {
    const {
      gridPositions,
      shouldShowGrid
    } = this.props;
    const {
      cellPositions,
      rowPositions
    } = gridPositions;
    return /*#__PURE__*/_jsxs(View, {
      display: shouldShowGrid ? 'block' : 'none',
      children: [rowPositions.map(this.renderOutline), cellPositions.map(this.renderOutline)]
    });
  }
}
export default connect(mapStateToProps)(LayoutSectionGridContainer);